import { apiFetch } from "@/lib/api-client";

export interface Prompt {
  company_id: number;
  key: string;
  template: string;
  variables_json: string;
  version?: number;
  updated_at?: string;
}

function withScope(path: string, scope?: string) {
  return scope ? `${path}${path.includes("?") ? "&" : "?"}scope=${encodeURIComponent(scope)}` : path;
}

export async function listPrompts(scope?: string) {
  return apiFetch<{ success: boolean; data: Prompt[] }>(withScope("/api/admin/prompts", scope));
}

export async function getPrompt(key: string, scope?: string) {
  return apiFetch<{ success: boolean; data: Prompt }>(
    withScope(`/api/admin/prompts/${encodeURIComponent(key)}`, scope),
  );
}

export interface UpsertPromptPayload {
  template: string;
  variables_json?: string;
}

export async function upsertPrompt(key: string, payload: UpsertPromptPayload, scope?: string) {
  return apiFetch<{ success: boolean }>(
    withScope(`/api/admin/prompts/${encodeURIComponent(key)}`, scope),
    { method: "PUT", body: JSON.stringify(payload) },
  );
}

export interface PreviewPromptPayload {
  template?: string;
  variables_json?: string;
  runtime_vars?: Record<string, unknown>;
}

export async function previewPrompt(key: string, payload: PreviewPromptPayload, scope?: string) {
  return apiFetch<{ success: boolean; rendered: string }>(
    withScope(`/api/admin/prompts/${encodeURIComponent(key)}/preview`, scope),
    { method: "POST", body: JSON.stringify(payload), timeoutMs: 30_000 },
  );
}
